export default {
  existing_documents: {
    description: 'Já carregou os seguintes documentos. Selecione um e prima enviar, ou carregue um novo documento.',
    sides: {
      front: 'Frente',
      back: 'Verso',
    },
    created_at: 'Carregado: {{date}}',
    expires_at: 'Expira: {{date}}',
  },
  document_types: {
    owner_document: 'Documento de identidade do proprietário',
    business_document: 'Documento comercial',
  },
  form: {
    document_type: {
      label: 'Comprovativo de documento comercial',
      placeholder: 'Selecionar tipo de documento',
      options: {
        vat_registration: 'Registo de IVA',
        trade_registration: 'Registo comercial',
        trade_license: 'Licença comercial',
        commercial_register_extract: 'Extrato do registo comercial',
        financial_statements: 'Demonstrações financeiras',
        other: 'Outro',
      },
    },
    front: {
      label: 'Frente do documento',
    },
    back: {
      label: 'Verso do documento (opcional para alguns documentos)',
    },
    expires_at: {
      label: 'Data de validade do documento',
      placeholder: 'Selecionar data de validade',
    },
  },
  buttons: {
    select_file: 'Selecionar ficheiro',
    next: 'Seguinte',
    back: 'Verso',
    send: 'Enviar',
    upload_new: 'Carregar novo documento',
    use_existing: 'Usar um documento carregado',
  },
};
